// extracted by mini-css-extract-plugin
export default {"linkWrapper":"scan-requests-trace-logs-table_linkWrapper__TZSxj"};